const envConfigs = {
	dev: {
		applicationInsightConnectionString:
			'InstrumentationKey=041b3eb7-66d6-4dc0-a334-80bfd7b2ca1b;IngestionEndpoint=https://westus3-1.in.applicationinsights.azure.com/;LiveEndpoint=https://westus3.livediagnostics.monitor.azure.com/',
		contentfulPreview: false,
	},
	tst: {
		applicationInsightConnectionString:
			'InstrumentationKey=6e5d8e6f-ba0a-43aa-afae-ae09a961307d;IngestionEndpoint=https://westus3-1.in.applicationinsights.azure.com/;LiveEndpoint=https://westus3.livediagnostics.monitor.azure.com/',
		contentfulPreview: false,
	},
	stg: {
		applicationInsightConnectionString:
			'InstrumentationKey=46c0c46e-55ee-4ce8-a419-8e7faed44cb1;IngestionEndpoint=https://westus3-1.in.applicationinsights.azure.com/;LiveEndpoint=https://westus3.livediagnostics.monitor.azure.com/',
		contentfulPreview: true,
	},
	prod: {
		applicationInsightConnectionString:
			'InstrumentationKey=0f1c6e3a-92fb-421d-ba37-14ab4062af40;IngestionEndpoint=https://westus3-1.in.applicationinsights.azure.com/;LiveEndpoint=https://westus3.livediagnostics.monitor.azure.com/',
		contentfulPreview: false,
	},
};

// function used to get different config ids based on the env passed in
// see helper util getEnvironment for how to get the env we are currently in
const getEnvConfig = (env, configName) => {
	if (!envConfigs[env]) {
		if (process.env.NODE_ENV === 'development') {
			// eslint-disable-next-line
			console.warn('config doesnt exist');
		}
		return null;
	}
	return envConfigs[env][configName];
};

export default getEnvConfig;
